import { Instagram, Phone, MapPin } from "lucide-react";
import { BUSINESS } from "../data";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative z-10 bg-[#050505] border-t border-white/10 pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row justify-between gap-10">
          <div>
            <p className="font-heading text-4xl md:text-5xl font-extrabold tracking-tighter text-white leading-none">
              MAREZ
            </p>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500 mt-2">
              {BUSINESS.tagline}
            </p>
            <p className="mt-6 max-w-sm text-sm text-zinc-500 leading-relaxed">
              {BUSINESS.serving}. Show-quality auto detailing for daily drivers,
              luxury cars, and exotics.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
            >
              <Phone size={16} /> {BUSINESS.phone}
            </a>
            <a
              href={BUSINESS.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-zinc-400 hover:text-white transition-colors"
            >
              <Instagram size={16} /> @{BUSINESS.instagram}
            </a>
            <span className="flex items-center gap-3 text-zinc-400">
              <MapPin size={16} /> {BUSINESS.location}
            </span>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            © {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-700">
            Premium Auto Care · Newark, CA
          </p>
        </div>
      </div>
    </footer>
  );
};
